import React from 'react';
import SwipeableTransferList from 'app/components/transferModule/content/SwipeableTransferList';
import { TransfersPerView } from 'app/components/transferModule/types/TransfersPerView';
import { useMediaQuery } from '@mui/material';
import { desktopContentWidth } from 'app/styles/media';
import TransferModulePlaceholder from 'app/components/transferModule/TransferModulePlaceholder';
import TransfersView from 'app/components/transferModule/content/TransfersView';
export default function ResponsiveTransferList(_ref) {
  let {
    transfers
  } = _ref;
  const isMobile = useMediaQuery("(max-width: ".concat(desktopContentWidth, "px)"));
  if (!transfers.length) {
    return /*#__PURE__*/React.createElement(TransferModulePlaceholder, null);
  }
  if (transfers.length <= (isMobile ? TransfersPerView.Mobile : TransfersPerView.Desktop)) {
    return /*#__PURE__*/React.createElement(TransfersView, {
      transferList: transfers
    });
  }
  return /*#__PURE__*/React.createElement(SwipeableTransferList, {
    transfers: transfers,
    transfersPerView: isMobile ? TransfersPerView.Mobile : TransfersPerView.Desktop,
    "data-sentry-element": "SwipeableTransferList",
    "data-sentry-component": "ResponsiveTransferList",
    "data-sentry-source-file": "ResponsiveTransferList.tsx"
  });
}